<template>
  <li
    class="nav-item"
  >
    <slot />
  </li>
</template>

<script>

export default {
  name: 'VNavItem',
};
</script>
